import { render, staticRenderFns } from "./seat-col.vue?vue&type=template&id=68d3ef2f&scoped=true&"
import script from "./seat-col.vue?vue&type=script&lang=js&"
export * from "./seat-col.vue?vue&type=script&lang=js&"
import style0 from "./seat-col.vue?vue&type=style&index=0&id=68d3ef2f&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68d3ef2f",
  null
  
)

export default component.exports